import React, { useMemo, useState } from "react";
import Select from "react-select";
import { X } from "lucide-react";
import { selectStyles } from "../../helpers";
import { THEME } from "../../theme/themeColors";

const multiStyles = {
  ...selectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 12000 }),
  control: (base, state) => ({
    ...(selectStyles.control ? selectStyles.control(base, state) : base),
    minHeight: 32,
    height: "auto",
  }),
  valueContainer: (base) => ({
    ...base,
    flexWrap: "wrap",
    paddingTop: 2,
    paddingBottom: 2,
  }),
  multiValue: (base) => ({
    ...base,
    background: THEME.alpha(0.12),
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: THEME.primaryHover,
    fontSize: 12,
  }),
};

const CompanyUsageModal = ({ templateName, rows, onClose, onCompanyClick }) => {
  const [selected, setSelected] = useState([]);

  const options = useMemo(() => {
    return [...rows]
      .map((c) => ({
        value: String(c.companyId),
        label: `${c.companyName || ""} (${c.companyId || ""})`,
      }))
      .sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: "base" }));
  }, [rows]);

  const visible = useMemo(() => {
    if (!selected.length) return rows;
    const ids = new Set(selected.map((s) => String(s.value)));
    return rows.filter((c) => ids.has(String(c.companyId)));
  }, [rows, selected]);

  return (
    <div className="mntu-overlay" onClick={onClose}>
      <div className="mntu-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mntu-modal-header">
          <h3>{templateName} — Companies</h3>
          <button type="button" className="mntu-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div className="mntu-modal-filter">
          <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            options={options}
            value={selected}
            onChange={(v) => setSelected(v || [])}
            styles={multiStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            placeholder="Filter company name / id"
            isClearable
          />
        </div>
        <div className="mntu-modal-body">
          <table className="mntu-table">
            <thead>
              <tr>
                <th>Company Name</th>
                <th>Company Id</th>
                <th>DoctorCount</th>
              </tr>
            </thead>
            <tbody>
              {visible.length === 0 ? (
                <tr>
                  <td colSpan={3} className="mntu-empty">No companies</td>
                </tr>
              ) : (
                visible.map((c) => (
                  <tr key={c.companyId}>
                    <td>
                      <button type="button" className="mntu-link" onClick={() => onCompanyClick(c)}>
                        {c.companyName}
                      </button>
                    </td>
                    <td>{c.companyId}</td>
                    <td>
                      <button type="button" className="mntu-link" onClick={() => onCompanyClick(c)}>
                        {c.doctorCount}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CompanyUsageModal;